import React from "react";
import { isEmpty } from "lodash";
import { Box, Typography, Chip } from "@material-ui/core";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";

// direct import
import "../style.scss";

const Household = ({ data }) => {
  return (
    <Box className="summary-renewal__card">
      <Typography className="summary-renewal__title">
        Household Interests
      </Typography>
      <Box className="household-tags__container">
        {data?.map((interest, index) => (
          <Chip key={index} label={interest} className="household-tags__chip" />
        ))}
        {isEmpty(data) && (
          <Box
            sx={{
              flexDirection: "column",
              height: 100,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <SentimentDissatisfiedIcon fontSize="large" />
            <Typography variant="h6">No data available.</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Household;
